module.exports = __webpack_public_path__ + "img/img1.3afbc033.jpg";